import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import BasePage from "@Scripts/Pages/BasePage";

export default class CookieTermsPage extends BasePage {
    public static async init() {
        await super.init();

        var cookie = CookieHelper.getCookiePolicy();
        if (cookie) {
            var values = cookie.split("|");

            if (values.indexOf("stat") !== -1) {
                document.querySelectorAll(".stat-status-on").forEach(doc => {
                    if (doc.classList.contains("hden")) {
                        doc.classList.remove("hden");
                    }
                });
            } else {
                document.querySelectorAll(".stat-status-off").forEach(doc => {
                    if (doc.classList.contains("hden")) {
                        doc.classList.remove("hden");
                    }
                });
            }

            if (values.indexOf("profile") !== -1) {
                document.querySelectorAll(".profile-status-on").forEach(doc => {
                    if (doc.classList.contains("hden")) {
                        doc.classList.remove("hden");
                    }
                });
                document.querySelectorAll(".profile-status-off").forEach(doc => {
                    doc.classList.add("hden");
                });
            } else {
                document.querySelectorAll(".profile-status-on").forEach(doc => {
                    doc.classList.add("hden");
                });
                document.querySelectorAll(".profile-status-off").forEach(doc => {
                    if (doc.classList.contains("hden")) {
                        doc.classList.remove("hden");
                    }
                });
            }
        }

        this.setCookiePolicyButtons();
    }

    private static setCookiePolicyButtons() {
        let buttonOptOutAll = document.getElementsByClassName("opt-out-all")[0];
        if (buttonOptOutAll) {
            buttonOptOutAll.addEventListener("click", (e) => {
                e.preventDefault();
                CookieHelper.removeCookiePolicyAll();
                window.location.href = window.location.href;
            });
        }

        let buttonOptInAll = document.getElementsByClassName("opt-in-all")[0];

        if (buttonOptInAll) {
            buttonOptInAll.addEventListener("click", (e) => {
                e.preventDefault();
                CookieHelper.setCookiePolicyAll();
                window.location.href = window.location.href;
            });
        }

        let buttonOptOuts = document.getElementsByClassName("opt-out");
        for (let buttonOptOut of buttonOptOuts) {
            buttonOptOut.addEventListener("click", (e) => {
                e.preventDefault();
                let dataType = <HTMLElement>e.target;
                CookieHelper.removeCookiePolicyType(dataType.dataset.type);
                window.location.href = window.location.href;
            });
        };

        let buttonOptIns = document.getElementsByClassName("opt-in");
        for (let buttonOptIn of buttonOptIns) {
            buttonOptIn.addEventListener("click", (e) => {
                e.preventDefault();
                let dataType = <HTMLElement>e.target;
                CookieHelper.setCookiePolicyType(dataType.dataset.type);
                window.location.href = window.location.href;
            });
        };
    }
}